"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var fromDateUtil_1 = require("@features/ItemLogPage/util/fromDateUtil");
var date_1 = require("@utils/date/date");
var duration_1 = require("@utils/date/duration");
var jobItemHistory_1 = require("@utils/jobItemHistory");
var clsx_1 = __importDefault(require("clsx"));
var date_fns_1 = require("date-fns");
var lodash_1 = __importDefault(require("lodash"));
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var i18n_1 = __importDefault(require("@/react-app/i18n"));
var getRefusalReasons_1 = require("../../../utils/getRefusalReasons");
var getEvent = function (status, queueName) {
    switch (status) {
        case 'remotely-approved':
            return 'Remotely-approved';
        case 'remotely-refused':
            return 'Remotely-refused';
        case 'manual-approved':
            return 'Manually-approved';
        case 'auto-approved':
            return 'Auto-approved';
        case 'manual-refused':
            return 'Manually-refused';
        case 'auto-refused':
            return 'Auto-refused';
        case 'reviewable':
            return "Sent to ".concat(queueName, " queue");
        case 'deferred':
            return "Sent to ".concat(queueName, " queue");
        case 'new':
            return 'Item received';
        case 'no-decision':
            return 'No decision';
        default:
            return '';
    }
};
var getImagesCounts = function (content) {
    if (!Array.isArray(content))
        return [0, 0, 0];
    var _a = __read(content.reduce(function (_a, curr) {
        var _b = __read(_a, 2), successCount = _b[0], failureCount = _b[1];
        if (curr.crawlingStatus === 'success') {
            return [successCount + 1, failureCount];
        }
        return [successCount, failureCount + 1];
    }, [0, 0]), 2), imageFetchSuccessCount = _a[0], imageFetchFailureCount = _a[1];
    return [imageFetchSuccessCount, imageFetchFailureCount, imageFetchSuccessCount + imageFetchFailureCount];
};
var getHistoryStatus = function (item) {
    var queueName = (0, jobItemHistory_1.getCurrentQueueName)(item);
    var status = (0, jobItemHistory_1.getFullJobStatusFilter)(item.meta.status, item.actor.domain);
    if (status === 'image-fetched') {
        var _a = __read(getImagesCounts(item.content), 3), imageFetchSuccessCount = _a[0], imageFetchFailureCount = _a[1], imagesCount = _a[2];
        if (imagesCount > 0) {
            var imageFetchedText = imageFetchSuccessCount > 1
                ? i18n_1.default.t('ITEM.HISTORY_MODAL.IMAGE_FETCHED_REACT_MANY', { count: imageFetchSuccessCount })
                : i18n_1.default.t('ITEM.HISTORY_MODAL.IMAGE_FETCHED_REACT_ONE_OR_ZERO', { count: imageFetchSuccessCount });
            var imageFailedText = imageFetchFailureCount > 0 ? i18n_1.default.t('ITEM.HISTORY_MODAL.IMAGE_FAILED_REACT', { imageFetchFailureCount: imageFetchFailureCount }) : '';
            return [imageFetchedText, imageFailedText];
        }
        return [];
    }
    var event = getEvent(status, queueName);
    var refusalReason = (0, getRefusalReasons_1.getRefusalReasonFromJobHistory)(item);
    var refusalReasonText = refusalReason ? " (".concat(refusalReason, ")") : '';
    var statusLabel = event + refusalReasonText;
    return [statusLabel];
};
function JobHistoryDisplay(_a) {
    var history = _a.history, domain = _a.domain, angularJsDependencies = _a.angularJsDependencies, minDate = _a.minDate;
    var t = (0, react_i18next_1.useTranslation)().t;
    var timeZone = (0, date_1.getUserTimezone)();
    var sortedHistory = lodash_1.default.sortBy(history, ['timestamp']);
    var historyWithDuration = sortedHistory.map(function (item, index) {
        return __assign(__assign({}, item), { event: getHistoryStatus(item), timeToPreviousItem: index - 1 >= 0
                ? " (+".concat((0, duration_1.duration)((0, date_fns_1.differenceInMilliseconds)(new Date(item.timestamp), new Date(sortedHistory[index - 1].timestamp)), false, duration_1.getDurationTextFromArray), ")")
                : '' });
    });
    return (react_1.default.createElement("div", { className: "history-container" },
        react_1.default.createElement("table", { className: "history-list" },
            react_1.default.createElement("tbody", null,
                react_1.default.createElement("tr", { className: "history-header" },
                    react_1.default.createElement("th", null,
                        " ",
                        t('ITEM.HISTORY_MODAL.EVENT')),
                    react_1.default.createElement("th", null,
                        " ",
                        t('ITEM.HISTORY_MODAL.ACTOR')),
                    react_1.default.createElement("th", null,
                        " ",
                        t('ITEM.HISTORY_MODAL.TIME'))),
                historyWithDuration.map(function (item, index) {
                    var _a, _b;
                    var isApprovedOrRefused = item.meta.status === 'approved' || item.meta.status === 'refused';
                    return (react_1.default.createElement("tr", { key: index, className: (0, clsx_1.default)('history__row', isApprovedOrRefused && 'white-background') },
                        react_1.default.createElement("td", { className: "history__event-type" },
                            react_1.default.createElement("i", { className: "item-event-type-icon item-event-type-icon--".concat(item.meta.status) }),
                            react_1.default.createElement("span", { className: "history__event-type__text truncated", title: item.event[0] }, item.event[0]),
                            react_1.default.createElement("span", { "data-ng-if": "item.event[1]", className: "history__event-type__text--error" }, item.event && item.event[1])),
                        item.actor && (react_1.default.createElement("td", null,
                            (item.actor.domain === 'agent' || item.actor.domain === 'client') && (react_1.default.createElement("div", null,
                                react_1.default.createElement("span", { className: "history__agent--actor", title: item.actor.id }, item.actor.id))),
                            item.actor.domain === 'processor' && (react_1.default.createElement("div", null, item.processingResults &&
                                item.processingResults.map(function (rule) {
                                    return (react_1.default.createElement("a", { key: rule.id, className: "history__agent--rule-link", title: rule.name, href: angularJsDependencies.href('app.assignment.automation.filterView', {
                                            domain: domain,
                                            filterId: rule.id,
                                            from: (0, fromDateUtil_1.maxFromDate)(rule.lastModifiedTime, minDate),
                                        }) }, rule.name));
                                }))))),
                        react_1.default.createElement("td", null,
                            react_1.default.createElement("span", { title: (_a = t('DASHBOARD.STATISTICS.TIMEZONE_TOOLTIP_R18N', { timeZone: timeZone })) !== null && _a !== void 0 ? _a : '' }, (0, date_1.formatDateWithSeconds)(new Date(item.timestamp))),
                            react_1.default.createElement("span", { className: "history__date__comparison", title: (_b = t('ITEM.HISTORY_MODAL.TOOLTIP')) !== null && _b !== void 0 ? _b : '' }, item.timeToPreviousItem))));
                })))));
}
exports.default = JobHistoryDisplay;
